import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Module from "global/sparta-module-utility";
import Utility from "community/module-utils-utility";
import urlCampaignCodeUtility from "community/url-campaign-code-utility";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";

const scope = {};
class linksModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'links-module', precompiled: {"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new linksModuleTemplates();
